export const EVENT_CONFIRMATION_LABELS = {
  resendEmailCTA: 'SEND CONFIRMATION EMAIL',
  confirmationBanner: {
    eventType: 'EVENT TYPE',
    rewardsId: 'REWARDS ID',
    confirmationNumber: 'CONFIRMATION NUMBER',
    eventName: 'EVENT NAME',
    bookingDate: 'BOOKING DATE',
    trackingNumber: 'TRACKING NUMBER',
    eventDate: 'EVENT DATE',
    eventSpace: 'EVENT SPACE',
    guestRooms: 'GUEST ROOMS',
  },
  contactInfoSummary: {
    title: 'Contact Information',
    contact: 'CONTACT',
    phoneAndEmail: 'PHONE AND EMAIL',
    companyName: 'COMPANY NAME',
    typeOfAccount: 'TYPE OF ACCOUNT',
    personal: 'Personal',
    business: 'Business',
    address: 'ADDRESS',
    accountRepresentativeName: 'MARRIOTT REPRESENTATIVE NAME',
    accountRepresentativeEmail: 'MARRIOTT REPRESENTATIVE EMAIL',
    additionalInformation: 'Additional Information',
  },
  resendConfirmationModal: {
    heading: 'Send Confirmation Email',
    body: 'Are you sure you want to send a confirmation e-mail to the event Planner?',
    sendCTA: 'SEND',
    cancelCTA: 'Cancel',
    successMessgae: 'Your e-mail request sent successfully!',
    failureMessage: 'Your e-mail request failed!',
  },
};

export const RESUBMIT_RFP = {
  title: 'Reprocess QuickGroup to SFA',
  qgIdsLables: {
    requiredError: 'Enter QuickGroup confirmation number.',
    label: `Enter QuickGroup Confirmation Id's (comma separated)`,
    ariaLabel: `Enter QuickGroup Confirmation Id's (comma separated)`,
  },
  submitCta: {
    ariaLabel: 'Submit QG ids',
    location: 'Resubmit QG page',
    description: 'Re Submit QG',
    label: 'Submit',
  },
  successMessage:
    'You request has been successfully submitted. Please check in SFA to see if QuickGroup(s) have been created.',
};
